module.exports = __webpack_public_path__ + "static/media/baja.877e3a38.gif";